import api from './auth';

export interface CreateTerminalTicketPayload {
  device_id: string;
  ttlSeconds?: number;
}

export interface TerminalTicketResponse {
  device_id: string;
  ticket: string;
  expiresAt: string;
  ssh_url: string;
  web_url: string;
}

export const createTerminalTicket = (data: CreateTerminalTicketPayload) =>
  api.post<TerminalTicketResponse>('/terminal/tickets', data);
